import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/admin/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.session_token) localStorage.setItem("ec_token", data.session_token);
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        if (data.is_admin) navigate("/admin", { state: { user: data } });
        else navigate("/admin/denied", { state: { user: data } });
      } catch (e) {
        if (e?.response?.status === 403) { navigate("/admin/denied"); return; }
        setError(true);
        setTimeout(() => navigate("/admin/login"), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-emerald-950 text-emerald-100">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-brass border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm">{error ? "Sign-in failed. Redirecting…" : "Signing you in…"}</p>
      </div>
    </div>
  );
}
